export { ArrowUpCircle as default } from './ArrowUpCircle';
